export default __webpack_public_path__ + "static/media/bloodbath1.c22e15e7.png";